import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeSubModal } from "../../features/modal/ModalSlice";
import { IoClose } from "react-icons/io5";
import { Accordion } from "react-bootstrap";
import { VscCallIncoming, VscCallOutgoing } from "react-icons/vsc";
import { PiPhoneCall } from "react-icons/pi";
import { FaPlus, FaRegNoteSticky, FaUserTie } from "react-icons/fa6";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { MdOutlineSubtitles, MdOutlineTitle } from "react-icons/md";
import CustomButton from "../Button/CustomButton";
import apiClient from "../../services/apiClient";
import { updateSipState } from "../../features/SIP/SIPCallsSlice";
import toast from "react-hot-toast";
import { formatDate } from "../../utils/utils";
import { CircularProgress } from "@mui/material";

const ActivityPopUp = () => {
  const [callLogs, setCallLogs] = useState([]);
  const [addNote, setAddNote] = useState();
  const [notes, setNotes] = useState();
  const [loading, setLoading] = useState(false);
  const [callLogsLoading, setCallLogsLoading] = useState(false);
  const [filter, setFilter] = useState({
    start_date: "",
    end_date: "",
    call_direction: "",
    callerid: "",
    callednum: "",
    callerid_and_or: "",
    callednum_and_or: "",
    forward_to: "",
    page: 1,
    limit: 10,
    OrgId: "",
  });

  const dispatch = useDispatch();

  const SIPCalls = useSelector((state) => state?.SIPCalls);
  const userInfo = useSelector((state) => state?.userInfo.user);

  useEffect(() => {
    fetchCallLogs();
  }, []);

  const fetchCallLogs = async (page = 1) => {
    try {
      setCallLogsLoading(true);
      let payload = {
        ...filter,
        // OrgId: userInfo?.company_domain,
        page,
        // forward_to: userInfo?.settings?.default_extension?.extension,
        // callerid: userInfo?.settings?.default_extension?.extension,
        // callerid_and_or: "or",
        // forward_to_and_or: "and",
        // extension: userInfo?.settings?.default_extension?.extension,
      };

      const response = await apiClient.post(
        `${process.env.REACT_APP_VOIP_SERVER_BASE_URL}/calls`,
        payload
      );
      const newLogs = response?.data || [];

      // Merge saved notes (stored in this backend, keyed by call_uuid) into the call logs
      const callUuids = newLogs.map((log) => log?.uuid).filter(Boolean);
      let notesMap = {};
      if (callUuids.length) {
        try {
          const notesRes = await apiClient.post(`/callActivity/notes/bulk`, {
            call_uuids: callUuids,
          });
          notesMap = notesRes?.data || {};
        } catch (notesErr) {
          console.log("Failed to fetch call notes:", notesErr);
        }
      }

      const mergedLogs = newLogs.map((log) => ({
        ...log,
        saved_notes: notesMap[log?.uuid] || "",
      }));

      setCallLogs(mergedLogs);
    } catch (err) {
      console.log(err);
      toast.error("Network Error");
    } finally {
      setCallLogsLoading(false);
    }
  };

  const toggleNotes = () => {
    setAddNote(!addNote);
  };

  const toggleActivitie = () => {
    dispatch(closeSubModal());
  };

  const handleSaveNote = async () => {
    try {
      setLoading(true);

      // Save tied to this exact call (call_uuid) and the phone number involved
      await apiClient.post(`/callActivity/notes`, {
        call_uuid: SIPCalls?.sipRecentCallUUID,
        phone_number: SIPCalls?.dialNumber || "",
        notes: notes,
        user_id: userInfo?.id,
        company_id: userInfo?.company_id,
      });

      dispatch(updateSipState({ key: "sipRecentCallUUID", value: "" }));
      toggleNotes();
      setNotes("");
      toast.success("Notes Added!");
      fetchCallLogs();
    } catch (err) {
      console.log(err);
      toast.error("Failed to save note. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={"activitie"}>
      <div className={`activitieScree`}>
        <h4 className="closeTitle d-flex justify-content-between">
          Activities
          <button onClick={toggleActivitie} className="close">
            <IoClose />
          </button>
        </h4>

        <div className="px-4 py-2">
          <div className="transparentBtn d-flex mb-3">
            <button className="ms-auto" onClick={toggleNotes}>
              <span className="me-1">
                <FaPlus />
              </span>{" "}
              Add a notes
            </button>
          </div>

          <div className={`${addNote ? "active" : ""} addNotes`}>
            
            <div className="notesForm mb-2">
              <div class="inputData withIcon mb-4">
                <span className="icon">
                  <MdOutlineTitle />
                </span>
                <input className="form-control" type="text" required />
                <label className="label">Notes Title</label>
              </div>

              <div class="inputData textareaData withIcon mb-2">
                <span className="icon">
                  <MdOutlineSubtitles />
                </span>
                <textarea
                  className="form-control h-auto"
                  rows="4"
                  cols="80"
                  required
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
                <label className="label">Type your notes here</label>
                {/* <div class="needHelp text-end">Need Help <span className="ms-1"><BsFillQuestionCircleFill /></span></div> */}
              </div>
              <div className="text-end mb-3">
                {/* <button
                  className="submitBtn"
                  
                >
                  Submit
                </button> */}
                <CustomButton
                  text="Submit"
                  style={{ borderRadius: "30px", padding: "4px 24px" }}
                  onClick={handleSaveNote}
                  disabled={!SIPCalls?.sipRecentCallUUID}
                  loading={loading}
                />
              </div>
            </div>

            <div className="cstAccordion">
              <div className="text-center">{callLogsLoading && <CircularProgress />}</div>
              <Accordion defaultActiveKey="0" flush>
                {/* <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span className="callIcon">
                      <VscCallOutgoing />
                    </span>{" "}
                    18 November, 10:30 PM
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <b className="d-block">Customer:</b>Hi, I've heard a lot about Greymatterz and
                      your expertise in AI. I run a mid level business, and I'm struggling to reach
                      the right audience online. Can you help me?
                    </p>
                    <p>
                      <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                      reaching out to us. We'd love to help. Could you tell me a bit more about your
                      business and the challenges you're facing in digital marketing?
                    </p>
                    <div className="addNote">
                      <div className="yourNote">
                        <span className="">
                          <MdOutlineSubtitles />
                        </span>{" "}
                        Notes
                      </div>
                      <p>
                        <b>Digital Marketing Manager:</b> Hi! Thank you for reaching out to us. We'd
                        love to help. Could you tell me a bit more about your business and the
                        challenges you're facing in digital marketing?
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <span className="callIcon">
                      <VscCallIncoming />
                    </span>{" "}
                    16 November, 10:30 PM
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                      reaching out to us. We'd love to help. Could you tell me a bit more about your
                      business and the challenges you're facing in digital marketing?
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <span className="callIcon">
                      <VscCallOutgoing />
                    </span>{" "}
                    18 November, 10:30 PM
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                      reaching out to us. We'd love to help. Could you tell me a bit more about your
                      business and the challenges you're facing in digital marketing?
                    </p>
                  </Accordion.Body>
                </Accordion.Item> */}
                {callLogs?.map((log, index) => (
                  <Accordion.Item eventKey={index}>
                    <Accordion.Header>
                      <span className="callIcon">
                        {log?.call_direction ? <VscCallOutgoing /> : <VscCallIncoming />}
                      </span>{" "}
                      {/* 18 November, 10:30 PM */}
                      {formatDate(log?.callstart)}
                    </Accordion.Header>
                    <Accordion.Body>
                      {/* <p>
                        <b className="d-block">Customer:</b>Hi, I've heard a lot about Greymatterz
                        and your expertise in AI. I run a mid level business, and I'm struggling to
                        reach the right audience online. Can you help me?
                      </p>
                      <p>
                        <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                        reaching out to us. We'd love to help. Could you tell me a bit more about
                        your business and the challenges you're facing in digital marketing?
                      </p> */}
                      <div className="addNote">
                        <div className="yourNote">
                          <span className="">
                            <MdOutlineSubtitles />
                          </span>{" "}
                          Notes
                        </div>
                        <p>{log?.saved_notes || log?.custom_disposition || "No Notes"}</p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityPopUp;
